import { Address, Customer, Interval, Job, JobRelatedEntitiesAndStats, Location, ModelObject, Price } from '@cco/model';
import { BillableItemAssociation } from './pricing/billable-item-association';
import { AmountWithUnit } from '@cco/model/lib/amount-with-unit';

export interface Project extends ModelObject<number> {
  id: number;
  name: string;
  interval: Interval;
  location?: Location;
  concreteVolume?: number;
  notes?: string;
  customerId: number;
  customer?: Customer;
  address?: Address;
  jobs?: Job[];
  billableItemAssociations?: BillableItemAssociation[];
  priceOverrides?: Price[];
}

export interface ProjectStats extends ModelObject<number> {
  totalBatchQuantity: AmountWithUnit;
  jobs: JobRelatedEntitiesAndStats[];
}

export const projectComparer = (a: Project, b: Project) => {
  if (a.interval == null && b.interval != null) return 1;
  if (a.interval != null && b.interval == null) return -1;
  return a.interval?.start && b.interval?.end && b.interval?.end?.localeCompare(a.interval?.end);
};
